import useAuth from "../hooks/use-auth";
import {useNavigate} from "react-router-dom";
import {FormProvider, useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import TextFormField from "@common/components/forms/text-form-field";
import PasswordFormField from "@common/components/forms/password-form-field";
import AppButton from "@common/components/app-button";
import {registerSchema, RegisterSchemaType} from "../constants/register-schema";
import React from "react";

const RegisterForm = () => {
    const {register, login} = useAuth();
    const navigate = useNavigate();

    const methods = useForm<RegisterSchemaType>({
        resolver: yupResolver(registerSchema),
        defaultValues: {
            email: '',
            password: '',
            confirmPassword: '',
        },
    });

    const {handleSubmit, formState: {isSubmitting}} = methods;

    const handleRegister = async () => {
        await methods.trigger();

        if (!methods.formState.isValid) {
            return;
        }

        const body = methods.getValues();
        try {
            await register(body);
            await login(body.email,body.password);
        } catch (error) {
            console.error("Login failed:", error);
        }
    };

    return (
        <FormProvider {...methods}>
            <form onSubmit={handleSubmit(handleRegister)} className="space-y-6">
                <TextFormField
                    name="email"
                    label="Email"
                    placeholder="Email"
                />

                <PasswordFormField
                    name="password"
                    label="Hasło"
                    placeholder="Hasło"
                    showPasswordToggle={true}
                />

                <PasswordFormField
                    name="confirmPassword"
                    label="Powtórz hasło"
                    placeholder="Powtórz hasło"
                    showPasswordToggle={true}
                />

                {methods.formState.errors.root && (
                    <div className="text-red-600 text-sm text-center">
                        {methods.formState.errors.root.message}
                    </div>
                )}

                <div className="flex items-center justify-between">
                    <AppButton
                        onClick={() => navigate(-1)}
                        type='button'
                        disabled={isSubmitting}
                        label="Cofnij"
                        className='!rounded-[4rem] !border-none text-primary text-[1rem] h-[40px] font-semibold bg-primary-alt hover:bg-primary-alt/80'/>

                    <AppButton
                        type='submit'
                        loading={isSubmitting}
                        label="Stwórz konto"
                        className='!rounded-[4rem] text-on-primary text-[1rem] h-[40px] font-semibold bg-primary hover:bg-primary/80'/>
                </div>
            </form>
        </FormProvider>
    );
}

export default RegisterForm
